<template>
  <div class="form-page">
    <g-title tag="h1" size="s">{{ formPage.Title }}</g-title>
    <g-markdown :content="formPage.Text" />

    <RadioGroup
      :label="formPage.AgeQuestionLabel"
      required
      :choices="[
        { Label: 'Under 10', Value: '-1', oval: true },
        { Label: '10', Value: '10' },
        { Label: '11', Value: '11' },
        { Label: '12', Value: '12' },
        { Label: '13', Value: '13' },
        { Label: '14', Value: '14' },
        { Label: '15', Value: '15' },
        { Label: '16', Value: '16' },
        { Label: '17', Value: '17' },
        { Label: '18+', Value: '18' }
      ]"
      @change="onAgeChange"
    />
    <RadioGroup
      v-for="(group, index) in formPage.AdditionalQuestions"
      :key="index"
      :entity="group.Entity"
      :wide="group.Wide"
      :label="group.Label"
      :choices="group.RadioChoices"
      @change="onAdditionalChange"
    />

    <RadioGroup
      v-if="age >= sexualOrientationAgeLimit"
      label="Har du en diagnostiserad neuropsykiatrisk funktionsnedsättning (NPF) som exempelvis ADHD eller autism (AST)?"
      :choices="[
        { Label: 'Ja', Value: '1' },
        { Label: 'Nej', Value: '0' },
        { Label: 'Vet inte', Value: '999' },
        { Label: 'Vill inte svara', Value: '99' }
      ]"
      :wide="true"
      @change="onNeuroFunctionChange"
    />

    <div v-if="formError" class="error-message">
      {{ formPage.ErrorMessage }}
    </div>
    <g-button
      :disabled="!$route.query.gdpr || age === 0 || loading"
      @click.prevent="startTest"
    >
      STARTA TESTET
    </g-button>
    <div class="required-info">* = obligatoriska uppgifter</div>
    <ecpat-modal name="gdpr-modal">
      <g-markdown :content="formPage.GDPRText" />
    </ecpat-modal>
  </div>
</template>

<script>
import RadioGroup from '@/components/RadioGroup';
import EcpatModal from '@/components/EcpatModal';

import GET_FORM_PAGE from '@/graphql/GetFormPage.gql';
import GET_STORIES_BY_USER from '@/graphql/story/GetStoriesByUser.gql';
import CREATE_STATISTIC from '@/graphql/story/CreateStatistic.gql';

/**
 * This variable is responsible at which age the sexual orientation question is shown
 * @type {number}
 */
const sexualOrientationAgeLimit = 14;

export default {
  components: {
    RadioGroup,
    'ecpat-modal': EcpatModal
  },
  apollo: {
    formPage: {
      query: GET_FORM_PAGE
    }
  },
  data() {
    return {
      formPage: {
        Title: '',
        Text: '',
        ErrorMessage: ''
      },
      age: 0,
      formData: {},
      formError: false,
      gdpr: false,
      skipData: 0,
      loading: false,
      neuroDisability: '',
      sexualOrientationAgeLimit // "Importing" the constant into the Vue Component
    };
  },
  mounted() {
    // Checks if the user has accepted the GDPR
    if (this.$route.query.skipData) {
      this.skipData = parseInt(this.$route.query.skipData, 10);
    }
  },
  methods: {
    showGdprModal() {
      //this.$modal.show('gdpr-modal');
    },
    startTest() {
      // Checks if the age options have been changed
      if (this.age === 0) {
        this.formError = true;
        return;
      }
      if (this.loading) return;
      this.loading = true;

      const userObj = {
        trafficSource: sessionStorage.getItem('traffic_source'),
        version: 5,
        formData: Object.assign(this.formData, {
          age: this.age,
          neuropsykiatrisk: this.neuroDisability,
          skip: this.skipData
        })
      };

      // Trying to create the statistic object with the current user data
      this.$apollo
        .mutate({
          mutation: CREATE_STATISTIC,
          variables: {
            input: {
              data: {
                Data: userObj
              }
            }
          }
        })
        .then(({ data }) => {
          // When the query has been successfully executed, the 'statistic_id' is returned
          // this id is attached to the user object and the user object is saved inside the session-storage

          // Checks if the age is valid for this context
          // if not, the user gets redirected to the finish page
          if (this.age < 0) {
            this.$router.push({ name: 'under-10' });
            return;
          }
          if (this.age === 18) {
            this.$router.push({ name: 'over-18' });
            return;
          }
          userObj['statistic_id'] = data.createStatistic.statistic.id;
          window.sessionStorage.setItem('userObject', JSON.stringify(userObj));

          // Querying 3 questions based on the users age
          // TODO: Change this so that more user data will be taken
          this.$apollo
            .query({
              query: GET_STORIES_BY_USER,
              variables: {
                userObj: JSON.stringify(userObj),
                limit: 5
              },
              fetchPolicy: 'network-only'
            })
            .then(({ data }) => {
              const stories = data.storiesByUser;
              // The returned story objects will be saved inside the session-storage
              window.sessionStorage.setItem(
                'story-loop',
                JSON.stringify(stories)
              );
              this.loading = false;
              // The user is redirected to the first story
              this.$router.push('/story/' + stories[0].id);
            })
            .catch(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onAgeChange(value) {
      this.formError = false;
      this.age = parseInt(value, 10);
    },
    onNeuroFunctionChange(value) {
      // Double Checking the age limit
      if (this.age < sexualOrientationAgeLimit) {
        return;
      }

      this.neuroDisability = value;
    },
    onPlacedAtChange(value) {
      this.formData['placerad_pa'] = Object.values(value).join(',');
    },
    onWhyPlacedChange(value) {
      this.formData['placerad_eget_beteende'] = value;
    },
    onAdditionalChange(value, entity) {
      this.formData[entity] = value;
    }
  }
};
</script>

<style lang="scss" scoped>
.error-message {
  color: #e20000;
  font-weight: 500;
}

.gdpr {
  margin-bottom: 30px;
}

.required-info {
  font-size: 14px;
}
</style>
